module.exports = "/lucky-balls/img/infobox/info_Box_002.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_002.png
// module id = 1067
// module chunks = 0